var _defs, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiGamePlayIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "mgp-1",
    x: 7,
    y: 9,
    width: 23,
    height: 21,
    rx: 5,
    ry: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "mgp-1",
    x: 34,
    y: 9,
    width: 23,
    height: 21,
    rx: 5,
    ry: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "mgp-1",
    x: 7,
    y: 34,
    width: 23,
    height: 21,
    rx: 5,
    ry: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "mgp-1",
    x: 34,
    y: 34,
    width: 23,
    height: 21,
    rx: 5,
    ry: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiGamePlayIcon);
export default __webpack_public_path__ + "static/media/multiGamePlayIcon.f16f2626220644b8c0abbed121cd9961.svg";
export { ForwardRef as ReactComponent };